import { render, staticRenderFns } from "./quaFlowList.vue?vue&type=template&id=668af682&scoped=true"
import script from "./quaFlowList.vue?vue&type=script&lang=js"
export * from "./quaFlowList.vue?vue&type=script&lang=js"
import style0 from "./quaFlowList.vue?vue&type=style&index=0&id=668af682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668af682",
  null
  
)

export default component.exports